import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AutoRenewalManagerService } from '../services/auto-renewal-manager.service';

@Component({
  selector: 'auto-renewal-flow',
  templateUrl: './auto-renewal-flow.component.html',
  styleUrls: ['./auto-renewal-flow.component.scss']
})
export class AutoRenewalFlowComponent implements OnInit {
  formData!: any;

  constructor(
    public route: ActivatedRoute,
    public autoRenewalManagerService: AutoRenewalManagerService
  ) { }

  ngOnInit(): void {
    if (!this.formData) {
      this.formData = this.autoRenewalManagerService.getFirstStep(this.route.snapshot.data.policy);
    }
  }
}
